import { render, staticRenderFns } from "./question.vue?vue&type=template&id=6735ceb2&scoped=true&"
import script from "./question.vue?vue&type=script&lang=js&"
export * from "./question.vue?vue&type=script&lang=js&"
import style0 from "./question.vue?vue&type=style&index=0&id=6735ceb2&prod&lang=less&scoped=true&"
import style1 from "./question.vue?vue&type=style&index=1&id=6735ceb2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6735ceb2",
  null
  
)

export default component.exports